import { Link } from 'react-router-dom'
import useTitle from '../../hooks/useTitle'
import { useTranslation } from 'react-i18next'
import AuthShell from '../../components/AuthShell'

/**
 * A drawn wax seal, in place of the ✅ emoji this screen used to open with.
 * Same engraved-circle language as the landing page's astrolabe.
 */
const Seal = () => (
    <svg
        className="auth__seal"
        viewBox="0 0 96 96"
        fill="none"
        stroke="currentColor"
        aria-hidden="true"
        focusable="false"
    >
        <circle cx="48" cy="48" r="45" strokeWidth="1" />
        <circle cx="48" cy="48" r="38" strokeWidth="5" strokeDasharray="1.2 10.7" />
        <circle cx="48" cy="48" r="31" strokeWidth="1" />
        <path
            d="M34 49.5 44 59.5 63 37"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const EmailConfirmed = () => {
    const { t } = useTranslation()
    useTitle(t('titles.emailConfirmed'))

    return (
        <AuthShell
            eyebrow={t('auth.emailConfirmed.eyebrow')}
            title={t('auth.emailConfirmed.heading')}
            links={[{ to: '/', label: t('auth.backToHome') }]}
        >
            <div className="auth__body">
                <Seal />
                <p className="auth__lead">{t('auth.emailConfirmed.body')}</p>
                <p>{t('auth.emailConfirmed.note')}</p>
                <div className="auth__actions">
                    <Link to="/login" className="btn">{t('auth.emailConfirmed.cta')}</Link>
                </div>
            </div>
        </AuthShell>
    )
}

export default EmailConfirmed
